module.exports = (__webpack_require__("dll-reference multiselect_v3"))("./node_modules/@studyportals/multiselect/dist/multiselect.js");